module.exports = __webpack_public_path__ + "img/public/AdminIcons/epandDownIcon.svg?90537558";